import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { useLocation, useParams } from 'react-router';
import { useFetchMgItemCard } from '@retail/products/data-access';
import { MgItemCard } from '@retail/products/types';
import { MgItemContainer, MgItemNotFound } from '@retail/products/containers';

export function MgItemPage() {
  const { itemNumber } = useParams<{ itemNumber: string; }>();
  const location = useLocation();
  const { hiddenBreadcrumbs } = location.state ?? {};

  const { data: mgItemCardDto } = useFetchMgItemCard(
    { mgItemNumber: Number(itemNumber) },
    { suspense: true }
  );
  const mgItem = mgItemCardDto && MgItemCard.fromDto(mgItemCardDto);

  return (
    <PageLayout maxWidth="full" spacing={2} fixedHeight>
      {mgItem ? (
        <SuspenseWithSentryErrorBoundary>
          <MgItemContainer mgItem={mgItem} hiddenBreadcrumbs={hiddenBreadcrumbs} />
        </SuspenseWithSentryErrorBoundary>
      ) : (
        <MgItemNotFound mgItemNr={itemNumber} />
      )}
    </PageLayout>
  );
}
